import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState, { MapLocationEntity } from "./state";
import { DroneEntity } from "@src/core/features";
import { DronesPageCollapseStatus } from "@src/features/drone/utils/operational-drones";

const slice = createSlice({
  name: 'DronePageReducer',
  initialState,
  reducers: {
    resetState: () => initialState,
    setSelectedDrone: (state, action: PayloadAction<DroneEntity | null>) => {
      state.selectedDrone = action.payload;
      // Clear missionId when drone is deselected or changed
      if (!action.payload) {
        state.missionId = undefined;
      }
    },
    toggleCollapse: (
      state,
      action: PayloadAction<DronesPageCollapseStatus>
    ) => {
      const status = action.payload;
      state.collapse[status] = !state.collapse[status];
    },
    setMapLocation: (state, action: PayloadAction<MapLocationEntity>) => {
      state.location = action.payload;
    },
    resetMapLocation: (state) => {
      state.location = undefined;
    },
    setShowTakeoffConfirm: (state, action: PayloadAction<boolean>) => {
      state.showTakeoffConfirm = action.payload;
    },
    setMissionId: (state, action: PayloadAction<string | undefined>) => {
      state.missionId = action.payload;
    },
    setHoveredDrone: (state, action: PayloadAction<DroneEntity | null>) => {
      state.hoveredDrone = action.payload;
    },
    setManualControl: (
      state,
      action: PayloadAction<{ serialNumber: string; isManualControl: boolean }>
    ) => {
      state.manualControl[action.payload.serialNumber] = action.payload.isManualControl;
    },
    addOptimisticMissionSerial: (state, action: PayloadAction<string>) => {
      const serial = action.payload;
      if (!serial) return;
      if (!state.optimisticMissionSerials.includes(serial)) {
        state.optimisticMissionSerials.push(serial);
      }
      // Re-entering a mission clears any leftover "ended" suppression for this drone, so a fresh
      // mission's route is never hidden by a stale end-mission flag.
      state.endedMissionSerials = state.endedMissionSerials.filter((s) => s !== serial);
    },
    removeOptimisticMissionSerials: (state, action: PayloadAction<string[]>) => {
      if (action.payload.length === 0) return;
      const toRemove = new Set(action.payload);
      state.optimisticMissionSerials = state.optimisticMissionSerials.filter(
        (serial) => !toRemove.has(serial),
      );
    },
    addEndedMissionSerial: (state, action: PayloadAction<string>) => {
      if (action.payload && !state.endedMissionSerials.includes(action.payload)) {
        state.endedMissionSerials.push(action.payload);
      }
    },
    removeEndedMissionSerials: (state, action: PayloadAction<string[]>) => {
      if (action.payload.length === 0) return;
      const toRemove = new Set(action.payload);
      state.endedMissionSerials = state.endedMissionSerials.filter(
        (serial) => !toRemove.has(serial),
      );
    },
  },
});

export default slice;

